/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import dateTimeFormat from 'lib/dateTimeFormat';

/**
 * ## Displays a date formatted by Intl.DateTimeFormat.
 * ### Renders only the supplied props. Prefer [Timestamp](/internal/components/Timestamp) unless you need a specifc output.
 *
 *
 * ```example
 * <Time date={new Date()} />
 * ```
 *
 * ```example
 * <Time
 *   date={new Date()}
 *   year="numeric"
 *   month="long"
 *   weekday="long"
 *   day="numeric"
 *   hour="numeric"
 *   hour12={false}
 *   minute="numeric"
 *   timeZoneName="long"
 * />
 * ```
 *
 * ```example
 * <Time
 *   date={new Date()}
 *   year="numeric"
 * />
 * ```
 *
 * ```example
 * <Time
 *   date={new Date()}
 *   year="2-digit"
 * />
 * ```
 *
 * ```example
 * <Time
 *   date={new Date()}
 *   month="narrow"
 * />
 * ```
 *
 * ```example
 * <Time
 *   date={new Date()}
 *   month="short"
 * />
 * ```
 *
 *
 * # TODO
 * * What is `timeZone` prop?
 */

class Time extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    year: PropTypes.oneOf(['numeric', '2-digit']),
    month: PropTypes.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
    weekday: PropTypes.oneOf(['narrow', 'short', 'long']),
    day: PropTypes.oneOf(['numeric', '2-digit']),
    hour: PropTypes.oneOf(['numeric', '2-digit']),
    hour12: PropTypes.bool,
    minute: PropTypes.oneOf(['numeric', '2-digit']),
    second: PropTypes.oneOf(['numeric', '2-digit']),
    timeZone: PropTypes.string,
    timeZoneName: PropTypes.oneOf(['short', 'long']),
  };

  render() {
    const { className, date, ...rest } = this.props;

    return <span className={className}>{dateTimeFormat(date, rest)}</span>;
  }
}

export default Time;
